// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tBWWP","buttons":"styles_buttons__2H37p"};